import { postRequestFile } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const createWorkticket = async (data) => {
  try {
    return await postRequestFile(urls.CREATE_WORK_TICKET, data);
  } catch (err) {
    return err;
  }
};
